export default __webpack_public_path__ + "static/media/Reports@32.e62f7ce9.svg";